import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import { normalizeCanisterTypeError } from './canister-type.util';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config.service";
var CanisterTypeHttpService = /** @class */ (function () {
    function CanisterTypeHttpService(configService) {
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    CanisterTypeHttpService.prototype.getCanisterType = function (serialNo) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-canister-type/' + encodeURIComponent(serialNo);
            API.get(_this.apiName, path, { response: false }).then(function (response) {
                observer.next(unwrapState(response));
                observer.complete();
            }).catch(function (error) {
                observer.error(normalizeCanisterTypeError(error));
            });
        });
    };
    CanisterTypeHttpService.prototype.setCanisterType = function (serialNo, canisterType) {
        var _this = this;
        return new Observable(function (observer) {
            API.post(_this.apiName, '/dashboard/canister-type', {
                response: false,
                body: {
                    serial_no: serialNo,
                    canister_type: canisterType
                }
            }).then(function (response) {
                observer.next(unwrapState(response));
                observer.complete();
            }).catch(function (error) {
                observer.error(normalizeCanisterTypeError(error));
            });
        });
    };
    CanisterTypeHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanisterTypeHttpService_Factory() { return new CanisterTypeHttpService(i0.ɵɵinject(i1.ConfigService)); }, token: CanisterTypeHttpService, providedIn: "root" });
    return CanisterTypeHttpService;
}());
export { CanisterTypeHttpService };
function unwrapState(response) {
    var payload = response && response.data;
    if (payload && typeof payload === 'object') {
        return payload;
    }
    return response;
}
